import React from "react";
import { GestureResponderEvent, Pressable } from "react-native";
import {
  backgroundColor,
  border,
  spacing,
  VariantProps,
} from "@shopify/restyle";
import { Box } from "app/components/common";
import { useRestyle } from "@shopify/restyle";
import { composeRestyleFunctions } from "@shopify/restyle";
import { position } from "@shopify/restyle";
import { opacity } from "@shopify/restyle";
import { visible } from "@shopify/restyle";
import { layout } from "@shopify/restyle";
import { shadow } from "@shopify/restyle";
import theme, { Theme } from "app/Theme/Theme";

type RestyleProps = VariantProps<Theme, "boxVariants"> &
  React.ComponentProps<typeof Box>;

const restyleFunctions = composeRestyleFunctions<Theme, RestyleProps>([
  position,
  spacing,
  border,
  opacity,
  backgroundColor,
  visible,
  layout,
  shadow,
]);

type Props = RestyleProps & {
  onPress: (event: GestureResponderEvent) => void;
  isDisabled?: boolean;
  children: React.ReactNode;
  style?: {};
  testID?: string;
  hitSlop?: {};
};

const PressableOpacity = ({
  children,
  onPress,
  isDisabled = false,
  style = {},
  testID = "",
  hitSlop = theme.hitSlop,
  ...rest
}: Props) => {
  const props = useRestyle(restyleFunctions, rest);

  const setOpacity = (pressed, hovered) => {
    if (pressed || isDisabled) {
      return 0.7;
    }
    if (hovered) {
      return 0.8;
    }
  };

  return (
    <Pressable
      {...props}
      testID={testID}
      hitSlop={hitSlop}
      disabled={isDisabled}
      style={({ pressed, hovered }) => [
        props.style,
        style,
        {
          opacity: setOpacity(pressed, hovered),
          cursor: "pointer",
        },
      ]}
      onPress={onPress}
    >
      {children}
    </Pressable>
  );
};

export { PressableOpacity };
